export default __webpack_public_path__ + "19562d2ffc501206da8e49766775e931.webp";